<template>
  <div>
    <div class="header relative">
      <!-- <p>欢迎使用生涯咨询中心预约系统!</p> -->
      <span @click="changLink('/message')">
        <el-badge v-if="homeInfo.latestMsgsNum && homeInfo.latestMsgsNum !== 0" :value="homeInfo.latestMsgsNum"
                  :max="99" class="headerDropdown">
        消息&nbsp;&nbsp;&nbsp;
        </el-badge>
      </span>
    </div>
    <!-- 公告 -->
    <el-card class="box-card">
      <div class="title clear">
        <h4 class="fl">公告</h4>
      </div>
      <ul class="mesList">
        <li v-for="notice in homeInfo.latestNotices" :key="notice.id" class="mesli">
          <el-button type="info" round size="mini" style="border: none; margin-right: 12px">{{
              notice.fromUnit
            }}
          </el-button>
          <span @click="enterNotice(notice)" style="cursor: pointer">{{ notice.title }}</span>
        </li>
      </ul>
    </el-card>
    <!-- AI咨询师 -->
    <el-card class="box-card">
      <div class="title clear aiTitle">
        <h4 class="fl"><i class="iconfont icon-rengongzhinengjiejuefanganicon"></i>AI咨询师</h4>
        <p class="tips">助你洞悉生涯困惑，规划未来路径</p>
        <p class="more" v-if="aiContent.length >= 2"
           @click="changLink('/aiConsult?home=home',AIConsultant)">
          更多</p>
      </div>
      <ul class="" v-if="aiContent && aiContent.length > 0">
        <li v-for="(item,index) in aiContent" :key="index" class="mesli aiquest"
            @click="changLink('/aiConsult?home=home',AIConsultant)">
          <p class="quest">{{ item.title }}</p>
          <p class="createTime">{{ item.chatCreateTime }}</p>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
      <el-button type="primary" round
                 @click="changLink('/aiConsult',AIConsultant)"
                 style="width: 100%;letter-spacing: 1px;font-size: 16px">开始AI咨询
      </el-button>
    </el-card>
    <!-- 指派测评 + 专家咨询 -->
    <el-card class="box-card">
      <!-- 专家咨询 -->
      <div class="title clear" @click="changLink('/appointView')">
        <h4 class="fl">专家咨询</h4>
        <small class="fr">更多</small>
        <ul class="mesList" v-if="homeInfo.latestSchedules && homeInfo.latestSchedules.length>0">
          <li v-for="schedule in homeInfo.latestSchedules" :key="schedule.id" class="mesli">
          <span>{{ schedule.planDate }} {{ schedule.planStartTime }}-{{
              schedule.planEndTime
            }}，{{ schedule.room.name }}，{{ schedule.teacher.teacherName }}</span>
          </li>
        </ul>
        <ul class="mesList" v-else>（无）</ul>
        <el-button type="primary" round
                 @click="changLink('/appointStep1')"
                 style="width: 100%;letter-spacing: 1px;font-size: 16px">专家咨询预约
      </el-button>
      </div>
      <!-- 指派测评 -->
      <div class="title clear" @click="changLink('/questAssign?code=0')">
        <h4 class="fl">指派测评</h4>
        <small class="fr">更多</small>
      </div>
      <ul class="mesList" v-if="homeInfo.assignQuests && homeInfo.assignQuests.length>0">
        <li v-for="(assignQuest,index) in homeInfo.assignQuests" :key="index" class="mesli">
          <span>
<!--            <i class="el-icon-star-on" style="color: red" />&nbsp;&nbsp;-->
            <el-badge is-dot class="mark"/>&nbsp;
            {{ assignQuest }} </span>
          <a class="fr" style="color: red" @click="changLink('/questAssign?code=1')">[开始]</a>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
      <!-- 代办 -->
      <div class="title clear">
        <h4 class="fl">待办</h4>
      </div>
      <ul class="mesList" v-if="homeInfo.reserveSchedules && homeInfo.reserveSchedules.length>0">
        <li v-for="schedule in homeInfo.reserveSchedules" :key="schedule.id" class="mesli">
          <span>
            <el-badge is-dot class="mark"/>&nbsp;
            咨询师：{{ schedule.teacher.teacherName }}，给你预留了1个预约：{{ schedule.planDate }}
            {{ schedule.planStartTime }}-{{ schedule.planEndTime }}</span>
          <a v-if="canConfirm(schedule)" class="fr" style="color: red" @click="confirmSchedule(schedule)">[处理]</a>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
      <!-- 联系预约员 + 来访者咨询指南 -->
      <div style="margin-top: 10px;">
        <span class="linkInner" @click.prevent="dialogContactShow = true">
        <i class="el-icon-phone iconmr"></i>联系预约员
      </span>
        <span class="linkInner text-right fr" @click.prevent="goGuide">
        <i class="el-icon-s-order iconmr"></i>来访者咨询指南
      </span>
      </div>
    </el-card>
    <!-- AI助理 -->
    <div class="ai">
      <div class="aiTips" v-show="aiTips">
        <p><span class="hi">HI~ 你好</span>,我是AI助理，可以帮助你快速了解本校政策相关的内容</p>
      </div>
      <img src="../images/ai1.png" class="aiAvatar"
           @click="changLink('/aiConsult',AIAssistant)"
           alt="alt">
    </div>

    <!-- <el-card class="box-card">
       @click="changLink('/myMes')-->
    <!-- <div class="title clear">
      <h4 class="fl">待办</h4>
    </div>
    <ul class="mesList" v-if="homeInfo.reserveSchedules && homeInfo.reserveSchedules.length>0">
      <li v-for="schedule in homeInfo.reserveSchedules" :key="schedule.id" class="mesli">
        <span>
          <el-badge is-dot class="mark" />&nbsp;
          咨询师：{{schedule.teacher.teacherName}}，给你预留了1个预约：{{ schedule.planDate }}
          {{ schedule.planStartTime }}-{{schedule.planEndTime}}</span>
        <a v-if="canConfirm(schedule)" class="fr" style="color: red" @click="confirmSchedule(schedule)">[处理]</a>
      </li>
    </ul>
    <ul class="mesList" v-else>（无）</ul>
  </el-card>-->
    <!-- <el-card class="box-card">
      <div class="title clear" @click="changLink('/appointView')">
        <h4 class="fl">近期咨询</h4>
        <small class="fr">更多</small>
      </div>
      <ul class="mesList" v-if="homeInfo.latestSchedules && homeInfo.latestSchedules.length>0">
        <li v-for="schedule in homeInfo.latestSchedules" :key="schedule.id" class="mesli">
          <span>{{ schedule.planDate }} {{ schedule.planStartTime }}-{{schedule.planEndTime
            }}，{{ schedule.room.name }}，{{schedule.teacher.teacherName}}</span>
        </li>
      </ul>
      <ul class="mesList" v-else>（无）</ul>
      <el-button type="primary" round style="width: 100%" @click="goappointStep1">我要预约</el-button>
    </el-card> -->
    <!--<el-card class="box-card">
       <span class="linkInner" @click.prevent="dialogContactShow = true">
        <i class="el-icon-phone iconmr"></i>联系预约员
      </span>
      <span class="linkInner text-right fr" @click.prevent="goGuide">
        <i class="el-icon-s-order iconmr"></i>来访者咨询指南
      </span>
    </el-card> -->
    <DialogContact v-if="dialogContactShow" :operatorContact="homeInfo.operatorContact"
                   @close-contact="closeContact"></DialogContact>
  </div>
</template>

<script>
import {mapState} from "vuex";
import HttpRequest from "@/utils/request";
import {formatTimeToStr} from "@/utils/date.js";
import DialogContact from '@/components/dialogContact'
import axios from "axios";

export default {
  components: {
    DialogContact,
  },
  data() {
    return {
      AIConsultant: {aiId: 1, appId: '67c20fd6bce44630ba11c1d209c747b5', aiName: 'AI咨询师'},
      AIAssistant: {aiId: 3, appId: 'afd7a7a7b20f4cef85d09d64658dc2c1', aiName: 'AI助理'},
      dialogContactShow: false,
      homeInfo: {},
      partner: null,
      aiContent: [],
      aiTips: true,
      // aiQuestList: [{quest: '做了那么多测评。对我有那些帮助呢？',createTime: '2024-11-11 9:00'},{quest: '我很关注我的学习，那些数据对我有用？',createTime: '2024-11-11 9:00'}]
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  beforeMount() {
    this.$bus.$on('close-confirm', this.closeConfirm)
  },
  mounted() {
    document.title = '生涯咨询预约中心'
    this.partner = this.$route.query.partner;
    this.getHomeInfo();
    this.aiHistoryList();
    setTimeout(() => {
      this.aiTips = false // 三秒后将关闭提示
    }, 3000);
  },
  methods: {
    aiHistoryList() {
      const options = {
        method: "GET",
        headers: {"content-type": "application/x-www-form-urlencoded"},
        params: {
          aiId: 1,
          appId: '67c20fd6bce44630ba11c1d209c747b5',
          token: this.student.token,
          pageSize: 2,
          current: 1,
          theme: "全部"
        },
        url: "/constub/AI/chat"
      };
      axios(options).then(res => {
        res = res.data;
        if (res && res.result.success) {
          this.aiContent = res.data.results
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    },
    handleSelect(index, indexPath) {
      this.$router.push(index);
    },
    goGuide() {
      this.$router.push("visitorConGuide");
    },
    goappointStep1() {
      this.$router.push("appointStep1");
    },
    handleCommand(command) {
      if (command === "logout") {
        store.dispatch("setLoginStatus", 0);
        this.$router.push("login?partner=" + this.partner);
      }
    },
    getHomeInfo() {
      let url = "/constub/getHomeInfo";
      let data = {token: this.student.token};
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.homeInfo = res.data;
        } else {
          this.$message({
            message: res.result.message,
            type: "error",
          });
        }
      });
    },
    canConfirm(schedule) {
      const now = new Date().getTime();
      const after24hour = schedule.planCreateTime + 24 * 60 * 60 * 1000;
      return now > schedule.planCreateTime && now < after24hour;
    },
    confirmSchedule(schedule) {
      // this.$router.push({ name: "appointReserve", params: { appoint: schedule } });
      this.$router.push('/appointReserve?scheduleId=' + schedule.id + '&pathfrom=home')
    },
    closeConfirm() {
      this.confirmShow = false;
    },
    changLink(link, params) {
      this.$router.push({path: link, query: params});
    },
    enterNotice(notice) {
      this.$alert(
        formatTimeToStr(notice.createTime) + " " + notice.content,
        notice.title,
        {
          confirmButtonText: "确定",
          showClose: false,
        }
      );
    },
    closeContact() {
      this.dialogContactShow = false;
    },
  },
};
</script>


<style scoped>
.ai {
  position: fixed;
  bottom: 80px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.aiTips {
  font-size: 14px;
  width: 192px;
  border: 2px solid #DCE4F1;
  padding: 3px 8px;
  box-sizing: border-box;
  border-radius: 18px;
  border-bottom-right-radius: 0;
  box-shadow: 0 10px 20px rgba(125, 174, 248, 0.5);
  z-index: 99;
  margin-right: 10px;
}

.aiTips .hi {
  color: #2560ae;
  font-weight: 550;
}

.aiAvatar {
  width: 70px;
  height: auto;
  animation: bounce 3s forwards ease-in-out;
  /* animation: rollIn 2s forwards ease-in-out; */
  cursor: pointer;
}

.headerDropdown {
  position: absolute;
  right: 20px;
  top: 0;
}

.mesList {
  clear: both;
  padding: 5px 0;
}

.mesList li {
  margin: 10px 0;
}

.mesList .el-button {
  padding: 5px 8px;
}

.linkInner {
  display: inline-block;
  width: 45%;
}

.aiquest {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #3D3D3D;
  /* font-weight: 530; */
  margin: 6px 0;
}

.aiquest .quest {
  width: 55%;
}

.aiquest .createTime {
  width: 39%;
}

.aiTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.aiTitle i {
  margin-right: 5px;
}

.aiTitle h4 {
  color: #A52A2A;
  letter-spacing: 1px;
  font-size: 15px;
  width: 34%;
}

.iconfont {
  font-size: 19px;
}

.aiTitle .tips {
  /* width: 40%; */
  margin: 0 10px;
}

.aiTitle .more {
  width: 15%;
  color: #409EFF;
}

</style>
